import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import firebase from "firebase/app";

interface IProps {
  user: firebase.User;
}

const GetToken = ({ user }: IProps) => {
  const [token, setToken] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  const getIdToken = async (user: firebase.User) => {
    const idToken = await user.getIdToken();
    setToken(idToken);
  };

  useEffect(() => {
    getIdToken(user);
  }, [user]);

  const handleLogOut = (event: React.MouseEvent) => {
    event.preventDefault();
    firebase.auth().signOut();
  };

  return (
    <div style={{ padding: 20 }}>
      <div>
        Logged in as <b>{user.email}</b>
        <p>
          <button onClick={handleLogOut}>Log out</button>
        </p>
      </div>
      {token && (
        <CopyToClipboard text={token} onCopy={() => setCopied(true)}>
          <button style={{ cursor: 'pointer', height: 40, background: '#334', color: 'white' }} onClick={(e) => e.preventDefault()}>Copy Id Token</button>
        </CopyToClipboard>
      )}
      <br></br>
      <br></br>
      {copied && <b>idToken has been Copied to Clipboard</b>}
    </div>
  );
};

export default GetToken;
